var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffboardedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFF4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.438 14.25a2.813 2.813 0 0 0-2.813 2.813v25.875a2.813 2.813 0 0 0 2.813 2.812h19.125a2.813 2.813 0 0 0 2.812-2.813V31.126A5.625 5.625 0 0 0 36.75 25.5h-2.813a2.813 2.813 0 0 1-2.812-2.813v-2.812A5.625 5.625 0 0 0 25.5 14.25h-5.063zM23.25 34.5c0-.621.504-1.125 1.125-1.125h11.25a1.125 1.125 0 0 1 0 2.25h-11.25A1.125 1.125 0 0 1 23.25 34.5zm1.125 3.375a1.125 1.125 0 0 0 0 2.25H30a1.125 1.125 0 0 0 0-2.25h-5.625z",
    fill: "#B54708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.457 14.724a7.844 7.844 0 0 1 1.918 5.151v2.813c0 .31.252.562.563.562h2.812c1.97 0 3.77.723 5.151 1.918a14.651 14.651 0 0 0-10.444-10.444z",
    fill: "#B54708"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffboardedIcon);
export default __webpack_public_path__ + "static/media/offboarded-icon.eafc3bd5063761a0ddb854e6c1714786.svg";
export { ForwardRef as ReactComponent };